import { Resource } from './resource';

export class Status extends Resource {
    name: string;
    value : string;
    label :string;
  }